import { lazy } from 'react'
// import Index from '../pages/index'
const Index = lazy(() => import('../pages/index/index'))
const Precept = lazy(() => import('../pages/Precept'))
const ContactUs = lazy(()=> import('../pages/ContactUs'))




const route = [
    {
        path: '/',
        key: 'Index',
        element: <Index/>,
    },

    {
        path: '/precept',
        key: 'precept',
        element: <Precept/>,
    },
    {
        path: '/contact',
        key: 'contact',
        element: <ContactUs/>,
    },


]
export default route;